export default "__VITE_ASSET__DDt_rPXB__"